import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Icon, Table } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { CoolFarmOptionsContext } from '../../..'

interface Props {
  id: string
  herdIndex: number
  index: number
  removeCrop: (index: number) => void
}

const CropItem:React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { id, herdIndex, removeCrop, index } = props
  const { control } = useFormContext()
  const options = useContext(CoolFarmOptionsContext)

  const cropOptions = options?.crops?.map(crop => ({
    key: crop.id,
    value: crop.id,
    text: crop.name
  })) || []

  const feedOptions = options?.feeds?.map(crop => ({
    key: crop.id,
    value: crop.id,
    text: crop.label
  })) || []

  return <Table.Row key={id}>
    <Table.Cell>
      <FormFields.Select
        control={control}
        name={`herdGroups[${herdIndex}].crops[${index}].id`}
        options={cropOptions}
        rules={{ required: true }}
        search
        placeholder={t('Select crop')}
        withoutLabel
        noErrorMessage
    />
    </Table.Cell>
    <Table.Cell>
      <FormFields.Select
        control={control}
        name={`herdGroups[${herdIndex}].crops[${index}].cftFeedId`}
        options={feedOptions}
        rules={{ required: true }}
        placeholder={t('Select feed')}
        withoutLabel
        noErrorMessage
    />
    </Table.Cell>
    <Table.Cell>
      <FormFields.Input
        control={control}
        name={`herdGroups[${herdIndex}].crops[${index}].dryMatterValue`}
        rules={{ required: true }}
        placeholder={t('Enter value')}
        typeInput='controled'
        allowDecimals
        decimalScale={2}
        withoutAsterisk
        noErrorMessage
    />
    </Table.Cell>
    <Table.Cell>
      <FormFields.Input
        control={control}
        name={`herdGroups[${herdIndex}].crops[${index}].freshWeightValue`}
        rules={{ required: true }}
        placeholder={t('Enter value')}
        typeInput='controled'
        allowDecimals
        decimalScale={2}
        withoutAsterisk
        noErrorMessage
    />
    </Table.Cell>
    <Table.Cell textAlign='center'>
      <Icon
        name='trash'
        color='red'
        style={{ cursor: 'pointer', fontSize: '1.2em' }}
        onClick={() => removeCrop(index)}
    />
    </Table.Cell>
  </Table.Row>
}
export default CropItem